
export default {
  head() {
    return {
      title: this.$t('submit.metaTitle'),
      meta: [
        {hid: 'description', name: 'description', content: this.$t('submit.metaDescription')},
        {hid: 'og:title', name: 'og:title', content: this.$t('submit.metaTitle')},
        {hid: 'og:description', name: 'og:description', content: this.$t('submit.metaDescription')},
        {hid: 'og:image', name: 'og:image', content: '~assets/img/showroom-fashionweek-bg.png'},
        {hid: 'og:url', name: 'og:url', content: process.env.NUXT_ENV_LOCAL_URL + '/propose/'}
      ],
      script: [{type: 'application/ld+json', json: this.structuredData}]
    }
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: '',
      files: [],
      success: false,
      structuredData: { // from https://schema.org/Seeks
        "@context": "https://schema.org",
        "@type": "Seeks",
        "areaServed": {
          "@type": "City",
          "name": "Paris"
        },
        "about": this.$t('submit.metaDescription'),
        "url": process.env.NUXT_ENV_LOCAL_URL + '/propose/'
      }
    }
  },
  computed: {
    legalLink() {
      return (
        process.env.NUXT_ENV_API_URL +
        `/static/legal/ml-${this.$i18n.getLocaleCookie()}.pdf`
      )
    }
  },
  methods: {
    returnToLastPage() {
      this.$router.go(-1)
    },
    async submit() {
      this.$store.dispatch('loading/start')
      const formData = new FormData()
      for (let index = 0; index < this.files.length; index++) {
        formData.append('proposalFiles[]', this.files[index])
      }
      formData.append('firstName', this.firstName)
      formData.append('lastName', this.lastName)
      formData.append('email', this.email)
      formData.append('phone', this.phone)
      formData.append('message', this.message)
      try {
        await this.$axios.post(
          process.env.NUXT_ENV_API_URL + '/propositions/',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        this.$store.dispatch('loading/end')
        this.success = true
        this.$router.push(this.localePath({
          query: {
            proposition_send: true
          }
        }))

      } catch (err) {
        this.$store.dispatch('loading/end')
        if (err.response && err.response.status === 400) {
          let message = "Une erreur s'est produite"
          if (err.response.data.message === 'Please send a last name') {
            message = 'Veuillez renseigner un nom'
          }
          if (err.response.data.message === 'Please send an email') {
            message = 'Veuillez renseigner un email'
          }
          const notification = {
            type: 'error',
            message
          }
          this.$store.dispatch('notification/add', notification)
        }
        console.error(err)
      }
    }
  }
}
